import React from "react";
import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => (
  <a
    href="https://wa.me/31852502086?text=Hallo%20Helios%20Bright%2C%20ik%20ontvang%20graag%20meer%20informatie%20over%20een%20thuisbatterij."
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full flex items-center justify-center text-white shadow-2xl transition-all hover:scale-110 animate-pulse-glow"
    style={{ background: "#25D366" }}
    data-testid="whatsapp-button"
    aria-label="WhatsApp"
  >
    <MessageCircle className="w-7 h-7" />
  </a>
);

export default WhatsAppButton;
